import { render, staticRenderFns } from "./ImportBuyOneGetOne.vue?vue&type=template&id=340bb34c&scoped=true&"
import script from "./ImportBuyOneGetOne.vue?vue&type=script&lang=js&"
export * from "./ImportBuyOneGetOne.vue?vue&type=script&lang=js&"
import style0 from "./ImportBuyOneGetOne.vue?vue&type=style&index=0&id=340bb34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340bb34c",
  null
  
)

export default component.exports